import img1 from "../../../assets/img/icon/payment.svg";
import img2 from "../../../assets/img/icon/exclusivedeals.svg";
import img3 from "../../../assets/img/icon/premium_service.svg";
import img4 from "../../../assets/img/icon/globalnetwork.svg";

export const ServiceData = [
  {
    
    icon: <img src={img3} style={{ width: "45px", height: "60px" }} />,
    heading: "Premium Services",
    para: "Experience unparalleled travel solutions with our expert team. From corporate bookings to luxury vacations, we ensure exceptional service at every step of your journey.",
  },
  {
    icon: <img src={img1} alt="Secure Payments" style={{ width: "45px", height: "60px" }}className="w-12 h-12" />,
    heading: "Secure Payments",
    para: "Enjoy complete peace of mind with our secure and reliable payment systems. We use  encryption and trusted payment gateways to protect your transactions.",
  },
  {
    icon: <img src={img4} alt="Global Network" style={{ width: "45px", height: "60px" }}className="w-12 h-12" />,
    heading: "Global Network",
    para: "Access our worldwide network of travel partners. With offices in Karachi, Islamabad, and London, we provide seamless international travel solutions.",
  },
  {
    icon: <img src={img2} alt="Exclusive Deals" style={{ width: "45px", height: "60px" }} className="w-12 h-12" />,
    heading: "Exclusive Deals",
    para: "Discover amazing travel deals and packages. Our partnerships with leading airlines and hotels allow us to offer competitive rates without compromising quality.",
  },
];
